/*PANTALLA DE CARGA INICIAL*/
import React, { useState, useEffect, useCallback } from 'react';

const LoadingScreen = ({ onLoaded }) => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  // Memoizar onLoaded para evitar re-renders innecesarios
  const handleLoaded = useCallback(() => {
    if (typeof onLoaded === 'function') {
      onLoaded();
    }
  }, [onLoaded]);

  useEffect(() => {
    // Simulación de progreso
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) return 100;
        return prev + 10;
      });
    }, 180);

    // Timer para completar la carga
    const loadingTimer = setTimeout(() => {
      setLoading(false);
      handleLoaded();
    }, 11000);

    // Cleanup
    return () => {
      clearInterval(progressInterval);
      clearTimeout(loadingTimer);
    };
  }, [handleLoaded]);

  return (
    <div className={`
      fixed inset-0 z-50 flex items-center justify-center
      bg-black transition-opacity duration-1000
      ${loading ? 'opacity-100' : 'opacity-0 pointer-events-none'}
    `}>
      {/* Video de fondo */}
      <video
        className={`
          absolute inset-0 w-full h-full object-cover
          transition-opacity duration-1000
          ${loading ? 'opacity-100' : 'opacity-0'}
        `}
        autoPlay
        muted
        loop
        playsInline
        aria-label="Loading background video"
        onError={(e) => {
          console.warn('❌ Error cargando video de fondo:', e);
        }}
      >
        <source src="/video/screen_load.mp4" type="video/mp4" />
        Tu navegador no soporta el elemento video.
      </video>

      {/* Overlay oscuro para mejor legibilidad */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Contenido del loading */}
      <div className={`
        relative z-10 text-center text-white px-6 max-w-lg mx-auto
        transition-all duration-1000
        ${loading ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
      `}>
        {/* Título principal con efecto de escritura */}
        <h1 className="
          text-4xl md:text-6xl font-bold mb-6
          bg-gradient-to-r from-white via-gray-200 to-white
          bg-clip-text text-transparent
          animate-pulse
        ">
          Sean Bienvenidos
        </h1>

        {/* Subtítulo */}
        <p className="
          text-lg md:text-xl text-gray-300 mb-8
          font-light tracking-wide
        ">
          Estamos cargando algo especial para ti...
        </p>

        {/* Círculo de carga animado */}
        <div className="flex justify-center mb-8">
          <div className="
            w-16 h-16 border-4 border-white/20 border-t-white
            rounded-full animate-spin
          " 
          aria-label="Loading indicator"
          />
        </div>

        {/* Barra de progreso */}
        <div className="mb-4">
          <div className="
            w-full h-2 bg-white/20 rounded-full overflow-hidden
            backdrop-blur-sm
          ">
            <div 
              className="
            h-full bg-gradient-to-r from-green-400 via-yellow-400 to-red-500
            transition-all duration-500 ease-outshadow-lg shadow-yellow-400/50
              "
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        {/* Porcentaje de progreso */}
        <p className="
          text-2xl font-bold text-white
          drop-shadow-lg
        ">
          {progress}%
        </p>

        {/* Puntos decorativos animados */}
        <div className="flex justify-center space-x-2 mt-6">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className={`
                w-2 h-2 bg-white rounded-full
                animate-bounce
              `}
              style={{ 
                animationDelay: `${i * 0.2}s`,
                animationDuration: '1.5s'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
